import apiClient from '@shared/api/apiClient';
/**
 * 문의 등록 API
 * POST /api/v1/inquiry
 * @param {Object} payload - RequestInqueryDTO 형식
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function createInquiry(payload) {
  const response = await apiClient.post('/v1/inquiry', payload, {
    withAuth: true,
  });

  return response.data;
}

/**
 * 문의 목록 조회 API
 * GET /api/v1/inquiry/list
 */
async function getInquiryList() {
  const response = await apiClient.get('/v1/inquiry/list', {
    withAuth: true,
  });

  return response.data.resultData;
}

/**
 * 관리자 문의 목록 조회 API
 * GET /api/v1/inquiry/admin
 * @param {Object} params - 검색 조건
 * {
 *   startDate,
 *   endDate,
 *   teamId,
 *   status,
 *   name
 * }
 */
async function getAdminInquiryList(params = {}) {
  const response = await apiClient.get('/v1/inquiry/admin', {
    params,
    withAuth: true,
  });

  return response.data.resultData;
}

/**
 * 관리자 문의 상태 / 답변 수정 API
 * PATCH /api/v1/inquiry/{idx}
 * @param {number} idx - 문의 식별값
 * @param {Object} payload
 * {
 *   companyCode,
 *   comment,
 *   status
 * }
 */
async function updateInquiry(idx, payload) {
  const response = await apiClient.patch(`/v1/inquiry/${idx}`, payload, {
    withAuth: true,
  });

  return response.data;
}
export { createInquiry, getInquiryList, getAdminInquiryList, updateInquiry };
